import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { fetchData, postData, SyncData, TripCustomerfetchData } from '../../../apiService';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Paper from '@mui/material/Paper';
import { Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';

const ExtraSaleOrderCreate = () => {
    const { id, tid } = useParams();

    const history = useHistory();
    const { isAuthenticated, companyId, userId, customerid, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
        fetchItemsTypes();
    }, [isAuthenticated, token, logout]);

    const [data, setData] = useState(null);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState('');
    const [singlediscount, setsingleDiscount] = useState('');
    const [GSTRate, setGSTRate] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [qty, setQty] = useState('');
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Remarks, setRemarks] = useState("");
    const [SaleRemarks, setSaleRemarks] = useState("");
    const [items, setitems] = useState('');
    const [isReturnsale, setisReturn] = useState('');
    const [Bundle, setBundle] = useState('');
    const [Pieces, setPieces] = useState('');
    const [LastBillDate, setLastBillDate] = useState("");
    const [LastBillAmount, setLastBillAmount] = useState("");
    const [Outstanding, setOutstanding] = useState("");
    const [pricetype, setpricetype] = useState('');
    const [Route, setRoute] = useState('');
    const[addressLine1, setaddressLine1]= useState('');

    useEffect(() => {
        const fetchTripDataFromApi = async () => {
            try {
                const response = await fetchData('executiveApi', `/${id}/${tid}`, token);
                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // console.error(dataArray);
                    dataArray.forEach(item => { });
                    setData(dataArray);
                    if (dataArray.length > 0) {
                        setCustomerName(dataArray[0].name);
                        setaddressLine1(dataArray[0].addressLine1);
                        setPaymentMode(dataArray[0].paymentType)
                        setTripdate(dataArray[0].orderDate);
                        setCustomerId(dataArray[0].id);
                        setpricetype(dataArray[0].customerpricetype);
                        setisReturn(dataArray[0].isReturns);
                        setLastBillDate(dataArray[0].latestBillDate);
                        setLastBillAmount(dataArray[0].latestBillAmount);
                        setOutstanding(dataArray[0].outstandingbalance);
                        setRemarks(dataArray[0].remarks);
                        setRoute(dataArray[0].route);

                    }
                }
            } catch (error) {
                console.error('Error fetching customer Data:', error);
            }
        };

        if (tid && id) {
            fetchTripDataFromApi();
        }
    }, [tid, id, token]);

    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');

    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const [QtyBundle, setQtyBundle] = useState('');
    const [QtyItem, setQtyItem] = useState('');

   
    const fetchItemsTypes = async () => {
        try {
            const response = await fetchData('ExtraLoadingAPI', `/Item/${companyId}/${tid}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.ItemId,
                    label: item.item,
                    quantity: item.quantity, // Include quantity in dropdown options
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    const handleItemChange = async (selectedOption) => {
        setSelectedItem(selectedOption);
        const selectedItemId = selectedOption.value;
        const selectedQuantity = selectedOption.quantity; // Fetch quantity directly from selected option
        setQtyItem(selectedQuantity); // Set the initial quantity in the state

        try {
            const response = await fetchData('ItemRateCheckingApi', `/${id}/${selectedItemId}`, token);

            if (response && response.response_data?.length > 0) {
                let itemFound = false;

                response.response_data.forEach(category => {
                    if (category.Items?.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                const { Rate, GSTRate, Weight, Bundle, QtyBundle } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setBundle(Bundle ?? 0);
                                setQtyBundle(QtyBundle ?? 0);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight,
                                    rate: Rate,
                                    GSTRate: GSTRate,
                                    Bundle: Bundle ?? 0,
                                    QtyBundle: QtyBundle ?? 0,
                                    quantity: selectedQuantity, // Set quantity in the new item
                                }));
                                itemFound = true;
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };

    const [newItem, setNewItem] = useState("");

    const handleQtyChange = (e) => {
        // Remove non-numeric characters
        const input = e.target.value.replace(/\D/g, '');

        // Parse input value or default to 0
        const quantity = parseInt(input) || 0;

        // Update Qty state
        setQty(input);

        // Perform calculations only if input is valid (numeric and non-negative)
        if (quantity >= 0) {
            const gstAmount = (rate * GSTRate) / 100; // GST amount per unit
            const totalAmount = rate * quantity; // Total without GST
            const totalPlusGst = totalAmount + gstAmount; // Total including GST
            const totalQuantity = newItem.weight * quantity; // Adjust total weight

            // Update newItem state with calculated values
            setNewItem((prevItem) => ({
                ...prevItem,
                quantity: quantity,
                totalAmount: totalAmount,
                GSTRate: GSTRate,
                gstAmount: gstAmount,
                totalPlusGst: totalPlusGst,
                discount: discount,
                totalQuantity: totalQuantity,
            }));
        }
    };

    useEffect(() => {
        const quantity = parseInt(qty) || 0;
        const gstAmount = (rate * GSTRate) / 100;
        const totalAmount = rate * quantity;
        const totalPlusGst = totalAmount + gstAmount;
        const bundle = Bundle;
        //const pieceCount = quantity % newItem.Bundle;
        setNewItem((prevItem) => ({
            ...prevItem,
            rate: rate,
            totalAmount: totalAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            discount: discount, // Ensure correct reference
            Bundle: bundle,
            //pieces: pieceCount,
        }));
    }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

    const [itemList, setItemList] = useState([]);

    const defaultItem = {
        Id: '',
        Name: '',
        quantity: 1,
        GSTRate: 0,
        rate: 0,
        totalAmount: 0,
        totalPlusGst: 0,
        discount: 0,
        weight: 0,
        totalQuantity: 0,
        rateperkg: 0,
        TotalAmtperkgwise: 0,
        GstPer: 0,
        gstAmount: 0,
        TaxableAmount: 0,
        Bundle: 0,
        Pieces: 0,
        singlediscount: 0,
    };

    const AddtoListdata = (e) => {
        e.preventDefault();
        // if (qty > 0) {
        if (QtyItem > 0) {
            const quantity = parseInt(QtyItem);
            //const bundleSize = parseInt(newItem.Bundle);
            const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0

            // Calculate number of bundles and remaining pieces
            // Check if bundleSize is valid (not null or 0)
            const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
            const pieceCount = bundleSize ? quantity % bundleSize : 0;


            // Your existing calculations
            // const rateperkg = rate / newItem.weight;
            const rateperkg = rate;
            const totalQuantity = newItem.weight * quantity;
            const totalAmount = rate * quantity;
            const TotalAmtperkgwise = rateperkg * totalQuantity;
            const TaxableAmount = ((rateperkg - discount) * totalQuantity * 100) / (100 + GSTRate);
            const gstAmount = (TaxableAmount * GSTRate) / 100;
            const GstPer = (gstAmount / TaxableAmount) * 100;
            const totalPlusGst = TaxableAmount + gstAmount;

            const updatedItem = {
                ...newItem,
                Name: selectedItem.label,
                Id: selectedItem.value,
                quantity: quantity,
                rate: rate,
                GSTRate: GSTRate,
                totalAmount: totalAmount,
                totalPlusGst: totalPlusGst,
                discount: discount,
                totalQuantity: totalQuantity,
                rateperkg: rateperkg,
                TotalAmtperkgwise: TotalAmtperkgwise,
                TaxableAmount: TaxableAmount,
                gstAmount: gstAmount,
                GstPer: GstPer,
                Bundle: numBundles,
                Pieces: pieceCount,
                QtyBundle: QtyBundle,
            };

            // Updating state
            setItemList([...itemList, updatedItem]);

            // Resetting newItem state
            setNewItem({
                Id: '',
                Name: '',
                quantity: 1,
                GSTRate: 0,
                rate: 0,
                totalAmount: 0,
                totalPlusGst: 0,
                discount: 0,
                weight: 0,
                totalQuantity: 0,
                rateperkg: 0,
                TotalAmtperkgwise: 0,
                GstPer: 0,
                gstAmount: 0,
                TaxableAmount: 0,
                Bundle: 0,
                pieces: 0,
            });

            // Resetting other state variables
            setNewItem({ ...defaultItem });
            setSelectedItem('');
            setQty('');
            setRate('');
            setGSTRate(0);
            setBundle('');
        }
    };

    const handleDiscountChange = (e, index) => {
        const value = parseFloat(e.target.value) || 0;
        const updatedItems = [...itemList];
        updatedItems[index].singlediscount = value;

        const TotalQuantity = updatedItems[index].totalQuantity || 0;
        const rateperkg = updatedItems[index].rateperkg || 0;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = rateperkg * TotalQuantity;
        const TaxableAmount = (((rateperkg - value) * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0;
        const gstAmount = (TaxableAmount * updatedItems[index].GSTRate / 100) || 0;
        const GstPer = (TaxableAmount !== 0) ? (gstAmount / TaxableAmount * 100) : 0;
        const totalPlusGst = TaxableAmount + gstAmount;

        updatedItems[index].totalPlusGst = totalPlusGst;
        updatedItems[index].discount = value;
        updatedItems[index].gstAmount = gstAmount;
        updatedItems[index].GstPer = GstPer;
        updatedItems[index].TaxableAmount = TaxableAmount;
        setItemList(updatedItems);
    };

    const handleQuantityChange = (e, index) => {
        const { value } = e.target;
        const updatedItems = [...itemList];
        const quantity = parseInt(value, 10);
        updatedItems[index].quantity = quantity;
    
        let bundleSize = 0;
        const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
        const bag = updatedItems[index].BagWeight || 0;
        const bagweight = updatedItems[index].weight || 0;
        let BagWeight = 0;
    
        if (bag > 0) {
          BagWeight = bag;
          bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
        } else if (bagweight > 0) {
          BagWeight = bagweight;
          bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;
        }
    
        const rateperkg = updatedItems[index].rateperkg || 0;
    
        const numBundles = bundleSize ? Math.floor(quantity / bundleSize) : 0;
        const pieceCount = bundleSize ? quantity % bundleSize : 0;
        // Calculate Total Quantity (Kgs)
        const TotalQuantity = BagWeight * quantity;
        updatedItems[index].totalQuantity = TotalQuantity;
    
        const RateAfterDiscount = rateperkg - DiscountPerPiece;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
    
        const TaxableAmount = ((RateAfterDiscount * TotalQuantity * 100) / (100 + updatedItems[index].GSTRate)) || 0;
        updatedItems[index].TaxableAmount = TaxableAmount;
    
        const gstAmount = (TaxableAmount * updatedItems[index].GSTRate / 100) || 0;
        updatedItems[index].gstAmount = gstAmount;
    
        const totalPlusGst = TaxableAmount + gstAmount;
        updatedItems[index].totalPlusGst = totalPlusGst;
    
        const totalAmount = RateAfterDiscount * quantity;
        updatedItems[index].totalAmount = totalAmount;
    
        updatedItems[index].Bundle = numBundles;
        updatedItems[index].Pieces = pieceCount;
    
        console.log("Updated Item:", updatedItems[index]); // Debug log to check updated values
    
        setItemList(updatedItems); // This should trigger a re-render with the updated state
      };
    
    const submitData = async (e) => {
        e.preventDefault();
        try {
            const itemsToSave = itemList.map(item => ({
                ItemId: item.Id,
                CustomerId: customerId,
                CompanyId: companyId,
                CategoryId: categoryId,
                ProductCategoryId: productCategoryId,
                rate: item.Rate,
                Quantity: item.quantity,
                Discount: item.discount ? item.discount : 0,
                BilledDate: new Date(),
                CreatedBy: userId,
                CreatedDate: new Date(),
                RatePerKg: item.rateperkg,
                DiscountPerPiece: item.singlediscount ? item.singlediscount : 0,
                RateAfterDiscount: (item.rateperkg - item.singlediscount),
                TotalQty: item.totalQuantity,
                BagWeight: item.weight,
                CGSTAmt: (item.gstAmount / 2),
                SGSTAmt: (item.gstAmount / 2),
                GSTAmt: item.gstAmount,
                TaxableAmt: item.TaxableAmount,
                NetAmt: item.totalPlusGst,
                Bundle: item.Bundle,
                Pieces: item.Pieces

            }));

            const saleorderdata = {
                TripId: tid,
                CustomerId: customerId,
                OrderDate: tripdate,
                SaleRemarks: SaleRemarks,
                CreatedBy: userId,
                CompanyId: companyId,
                CreatedDate: new Date(),
                OrderType: 1,
            };

            const CreateData = {
                SaleOrder: saleorderdata,
                SaleOrderDetails: itemsToSave,
            };

            // Show a confirmation dialog before submitting the order
            const confirmOrder = window.confirm('Are you sure you want to confirm the order?');
            if (confirmOrder) {
                postData('ExtraLoadingAPI', CreateData, token)
                    .then((response) => {
                        if (response.response === '1111') {
                            const SaleOrderid = response.SaleOrderId;
                            history.push(`/ExtraLoadingSaleIndex`);
                        }
                    })
                    .catch((error) => {
                        console.error('SaleOrder Create error:', error);
                    });
            }
        } catch (error) {
            console.error('Submit error:', error);
        }
    };

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);

    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };

    const [showModal, setShowModal] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const opendatamodal = () => {
        handleHistoryClick(id);
        setShowModal(true);
    };

    const handleHistoryClick = async (id) => {
        try {
            const response = await fetchData('OrderSummaryApi', `/${companyId}/${id}`, token);
            if (response.responseCode === '1111') {
                setFilteredData(response.response_data);
                setShowModal(true);
                // console.log('Modal state set to true:', showModal);
            } else {
                console.error('Invalid response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    return (
        <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ maxWidth: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '2000px', overflowY: 'auto' }}>
            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginLeft: '-5px', marginTop: '-20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', overflowY: 'auto' }}>

                <form onSubmit={submitData}>
                    <div className="flex mb-2" style={{ justifyContent: "flex-end", marginTop: '5PX' }}>

                        {isReturnsale && (
                            <Link to={`/SaleOrderReturn/${customerId}`}>
                                <Button style={{ background: '#FF003F', color: 'white', fontWeight: '600', marginLeft: '100px', fontSize: '12px', height: '30px' }}> Sale Return</Button>
                            </Link>
                        )}
                        <Button variant="contained" color="secondary" onClick={() => opendatamodal()} style={{ marginLeft: '20px', fontSize: '12px', height: '30px' }}>Summary</Button>

                        <Button variant="contained" color="primary" type="submit" style={{ width: "150px", fontSize: '12px', backgroundColor: 'yellowgreen', marginLeft: '10px', height: '30px' }}><strong>Order Confirm</strong></Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to={`/ExtraLoadingSaleIndex/${tid}`}
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            CANCEL
                        </Button>
                    </div>
                    <div className="flex mb-2" style={{ marginTop: '-50px' }}>
                        <h5 className="flex-grow text-black font-serif" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                            <p style={{ color: 'darkmagenta' }}>{customerName} {addressLine1}</p>
                        </h5>
                        <h6 className="flex-grow text-black font-serif" style={{ marginLeft: '-250px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', fontWeight: 'bolder' }}>
                            <p style={{ color: 'darkred' }}>Route: {Route}</p>
                        </h6>
                    </div>

                    {/* LastBill deatils */}
                    <div className="flex mb-2" style={{ marginTop: '-10px' }}>
                        <h6 className="flex-grow text-black" style={{ fontSize: '14px' }}>
                            Last Bill Date: <strong>{LastBillDate && new Date(LastBillDate).toLocaleDateString('en-GB')}</strong>
                        </h6>
                        <h6 className="flex-grow text-black" style={{ marginLeft: '-140px', fontSize: '14px' }}>
                            Last Bill Amount : <strong>{LastBillAmount}</strong>
                        </h6>
                        <h6 className="flex-grow text-black" style={{ marginLeft: '-150px', fontSize: '14px' }}>
                            Outstanding Balance : <strong>{Outstanding}</strong>
                        </h6>

                        <h6 className="flex-grow text-black" style={{ fontSize: '14px' }}>
                            Order Date : <strong>{tripdate && new Date(tripdate).toLocaleDateString('en-GB')}</strong>
                        </h6>
                        <h6 className="flex-grow text-black" style={{ marginLeft: '-140px', fontSize: '14px' }}>
                            Price Type : <strong>{pricetype}</strong>
                        </h6>
                        <h6 className="flex-grow text-black" style={{ marginLeft: '-150px', fontSize: '14px' }}>
                            Payment Mode : <strong>{paymentMode}</strong>
                        </h6>
                    </div>
                    <br />

                    <div className="w-full mb-4 flex" style={{ marginTop: '-30px' }}>
                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="Remarks" style={{ fontSize: '14px' }}>
                                Remarks
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={SaleRemarks} onChange={(e) => setSaleRemarks(e.target.value)} type="text" placeholder="" />
                        </div>

                        <br />
                        <div className="w-full mb-4 flex">

                            <div className="w-1/2 mr-2">
                                <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px', width: '200px' }}>
                                    Variant with Bagweight
                                </label>
                               
                                <Select
                                    options={itemOptions}
                                    onChange={handleItemChange}
                                    placeholder="Select Item"
                                />
                            </div>
                            <div className="w-1/8 mr-2" >
                                <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Quantity" style={{ fontSize: '15px' }}>
                                    QTY (No.of pieces)

                                </label>
                                
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={QtyItem} // Controlled input value
                                    onChange={(e) => {
                                        // Parse the input value as an integer
                                        let inputValue = parseInt(e.target.value, 10);

                                        // If the input is empty or invalid, reset to the minimum (1)
                                        if (isNaN(inputValue) || inputValue < 1) {
                                            inputValue = 1;
                                        }

                                        // Update state with the parsed and validated value
                                        setQtyItem(inputValue);
                                    }}
                                    type="number"
                                    placeholder="Quantity"
                                    style={{ width: '150px', height: '37px' }}
                                    min={1} // Minimum value for the input field
                                    onClick={(e) => e.target.select()} // Select the value when clicked

                                />


                            </div>
                            <div className="w-1/7 mr-2">
                                <Button variant="contained" color="primary" onClick={AddtoListdata} style={{ marginTop: '32px', marginLeft: '10px', fontSize: '12px' }}>Add Item</Button>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}
                    {showModal && (
                        <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                            <div className="fixed inset-0 flex items-start justify-center z-10 ">
                                <div className="bg-green-100 p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto', marginTop: '50px' }}>
                                    <div className="flex justify-end mt-2">
                                        <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-10px', color: 'black' }}>
                                            <Tooltip title="Close">
                                                <FaTimes />
                                            </Tooltip>
                                        </button>
                                    </div>

                                    <TableContainer component={Paper} style={{ marginTop: '15px' }}>
                                        <Table>
                                            <TableHead sx={{ backgroundColor: '#58A566' }}>
                                                <TableRow>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', width: '50px', textAlign: 'center' }}>Sl.No</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', width: '50px', textAlign: 'center' }}>Invoice Date</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'left' }}>Item Name</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Quantity</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Net Amount</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total CGST Amount</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total SGST Amount</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Discount Amount</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '12px', padding: '5px', color: 'whitesmoke', textAlign: 'center' }}>Total Amount</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody sx={{ backgroundColor: '#9BC1B3' }}>
                                                {filteredData && filteredData.length > 0 && (
                                                    filteredData.reduce((acc, item, index, array) => {
                                                        // Calculate the total amount for the current day
                                                        const currentDayTotal = array
                                                            .filter(data => data.InvoiceDate === item.InvoiceDate)
                                                            .reduce((sum, data) => sum + data.TotalAmount, 0);

                                                        // Add the current row to the accumulator
                                                        acc.push(
                                                            <TableRow key={item.id}>   <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', width: '50px', textAlign: 'center' }}>
                                                                {index + 1}
                                                            </TableCell>

                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', width: '50px', textAlign: 'center' }}>
                                                                    {item.InvoiceDate && new Date(item.InvoiceDate).toLocaleDateString('en-GB')}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'left' }}>
                                                                    {item.ItemName}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                    {item.TotalQuantity}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                    {item.NetAmount.toFixed(2)}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                    {item.TotalCGSTAmount.toFixed(2)}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                    {item.TotalSGSTAmount.toFixed(2)}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                    {item.TotalDiscountAmount}
                                                                </TableCell>
                                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', borderRight: '1px solid #F5F5F5', color: 'black', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                    {item.TotalAmount.toFixed(2)}
                                                                </TableCell>
                                                            </TableRow>
                                                        );

                                                        // Check if the next item has a different InvoiceDate or if it's the last item
                                                        if (index === array.length - 1 || item.InvoiceDate !== array[index + 1].InvoiceDate) {
                                                            acc.push(
                                                                <TableRow key={`total-${item.InvoiceDate}`}>
                                                                    <TableCell colSpan={9} sx={{ borderBottom: '1px solid #F5F5F5', backgroundColor: '#201658', color: 'white', fontWeight: 'bold', padding: '5px', fontSize: '12px', textAlign: 'center' }}>
                                                                        Total: {currentDayTotal.toFixed(2)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        }

                                                        return acc;
                                                    }, [])
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </Modal>
                    )}


                    {/* <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '400px', overflowY: 'auto' }}> */}

                    <div className="w-full mb-4 flex" style={{ marginTop: '-20px', maxWidth: '115%' }}>
                        <div className="w-full mb-4 flex">
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="px-4 py-2 text-left text-sm font-medium" style={{ width: '1%', fontSize: '13px', fontWeight: 'bolder', textAlign: 'left' }}>Sl.No</th>
                                            <th className="px-4 py-2 text-left text-sm font-medium" style={{ width: '17%', fontSize: '13px', fontWeight: 'bolder' }}>Name</th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ fontSize: '13px', fontWeight: 'bolder' }}>Qty
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(No.Pieces)</p>
                                            </th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'left', width: '12%', fontSize: '12.5px', fontWeight: 'bolder' }}>Total Qty
                                                <p style={{ fontSize: '11px', marginBottom: '-10px' }}>(Kgs)</p>
                                            </th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '2%', fontSize: '12.5px', fontWeight: 'bolder' }}>Bundle</th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '2%', fontSize: '12.5px', fontWeight: 'bolder' }}>Pieces</th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '13px', fontWeight: 'bolder' }}>Rate/Kg
                                                <p style={{ fontSize: '10px', marginBottom: '-10px' }}>(Including Tax)</p>
                                            </th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '3%', fontWeight: 'bolder', fontSize: '12.5px' }}>Discount</th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ textAlign: 'center', width: '14%', fontSize: '12.5px', fontWeight: 'bolder' }}>Rate
                                                <p style={{ fontSize: '9.5px', marginBottom: '-10px' }}>(After Discount)</p>
                                            </th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '12%', textAlign: 'left', fontSize: '12.5px', fontWeight: 'bolder' }}>Taxable Amt </th>
                                            {/* <span style={{ fontSize: '12px' }}>Amt</span> */}
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '3%', textAlign: 'left', fontSize: '12.5px', fontWeight: 'bolder' }}>GST%</th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '12.5px', fontWeight: 'bolder' }}>
                                                GST (₹)
                                            </th>
                                            <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '13px', fontWeight: 'bolder' }}>Total</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {itemList.map((item, index) => (
                                            <tr key={index}>
                                                <td className="px-4 py-2 border-r text-left text-sm" style={{ width: '1%' }}>{index + 1}</td>
                                                <td className="px-4 py-2 border-r text-left text-sm" style={{ width: '15%', fontWeight: 'bold', fontSize: '13px' }}>{item.Name}</td>
                                                <td className="border-r " style={{ padding: '1px', width: '7%', textAlign: 'center', '#ffcccc': 'inherit', fontSize: '14px' }}>
                                                    <input
                                                        type="number"
                                                        value={item.quantity}
                                                        onChange={(e) => handleQuantityChange(e, index)}
                                                        style={{ maxWidth: '120px', textAlign: 'right' }}
                                                        min="0"
                                                        step="1"
                                                        onClick={(e) => e.target.select()}
                                                    // max={QtyItem}
                                                    />
                                                </td>
                                                {/* <td className="px-4 py-2 border-r text-right text-sm" >{item.totalQuantity}</td> */}
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.totalQuantity}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.Bundle}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.Pieces}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm">{item.rateperkg}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >
                                                    <input
                                                        type="number"
                                                        value={(isNaN(item.singlediscount) || item.singlediscount === "") ? '0' : item.singlediscount}
                                                        onChange={(e) => handleDiscountChange(e, index)}
                                                        className="w-full px-2 py-1 border rounded text-sm"
                                                        step="0.01"
                                                        min="0"
                                                        style={{ width: '145%', marginLeft: '-20%' }}
                                                        onClick={(e) => e.target.select()}
                                                    />
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm">
                                                    {(isNaN(item.rateperkg - item.singlediscount) || item.rateperkg - item.singlediscount === "")
                                                        ? '0'
                                                        : (item.rateperkg - item.singlediscount).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm">
                                                    {(isNaN(item.TaxableAmount) || item.TaxableAmount === "")
                                                        ? (item.TaxableAmount).toFixed(2)
                                                        : (item.TaxableAmount).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" >{item.GSTRate}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm">{item.gstAmount.toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm">{(item.totalPlusGst).toFixed(2)}</td>
                                                <td>
                                                    <Tooltip title="Delete">
                                                        <DeleteIcon
                                                            style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                            onClick={() => openConfirmDialog(index)}
                                                        />
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td className="px-4 py-2 border-r text-left text-sm" colSpan="2">Total</td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.quantity, 0)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.totalQuantity, 0)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Bundle, 0)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Pieces, 0)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm"></td>
                                            <td className="px-4 py-2 border-r text-right text-sm">
                                                {itemList.reduce((acc, item) => {
                                                    const singleDiscount = Number(item.singlediscount) || 0;
                                                    return acc + singleDiscount;
                                                }, 0).toFixed(2)}
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm">
                                                {itemList.reduce((acc, item) => {
                                                    const ratePerKg = Number(item.rateperkg) || 0;
                                                    const singleDiscount = Number(item.singlediscount) || 0;
                                                    if (!isNaN(ratePerKg) && !isNaN(singleDiscount)) {
                                                        return acc + (ratePerKg - singleDiscount);
                                                    } else {
                                                        return acc;
                                                    }
                                                }, 0).toFixed(2)}
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.TaxableAmount, 0).toFixed(2)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm"></td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.gstAmount, 0).toFixed(2)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.totalPlusGst, 0).toFixed(2)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm"></td>
                                        </tr>
                                    </tfoot>

                                </table>

                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>

                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={() => handleDelete(itemToDeleteIndex)}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm ``
                                        </button>
                                    </DialogActions>

                                </Dialog>
                            </TableContainer>

                        </div>
                    </div>

                    {/* </div> */}
                </form >
            </div >
        </div >
    );
};

export default ExtraSaleOrderCreate;
